'use strict';

module.exports = require('./es2016');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/es-abstract/es7.js
// module id = 1507
// module chunks = 168707334958949